import { Injectable, ViewContainerRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/toPromise';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import swal, { SweetAlertOptions} from 'sweetalert2';

@Injectable()
export class NoopInterceptor implements HttpInterceptor {
  public vcr: ViewContainerRef;
  constructor(
  ) {
  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const started = Date.now(),
      // full = req.clone({ url: 'http://dev.ccsttc.com/api' + req.url });
      full = req.clone({ url: 'http://go.ccsttc.com/api' + req.url, withCredentials: true });
      console.log(full);
      const result = next
      .handle(full)
      .do(event => {
        if (event instanceof HttpResponse) {
          if (event.ok) {
            if (event.body.code !== 200) {
              return swal({
                type: 'warning',
                title: '失败',
                text: '操作失败: ' + event.body.msg.replace('Error', ''),
                showConfirmButton: false,
                timer: 1500
              });
            }
          } else {
            return swal({
              type: 'error',
              title: '失败',
              text: '网络连接失败',
              showConfirmButton: false,
              timer: 1500
            });
          }
        }
      });
    return result;
    /** 缓存请求写法
     https://angular.cn/guide/http#拦截所有的请求和响应。
    */
  }
}



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/lib/interceptor/http.ts